import { inject, observer } from "mobx-react";
import React from "react";
import { ReactComponent as CloseIcon } from '../../../svg/close.svg'
import { ReactComponent as CaretDown } from '../../../svg/caret-down.svg'
import { HexColorPicker, HexColorInput } from "react-colorful";
import "react-quill/dist/quill.snow.css";
import ReactQuill, { Quill } from 'react-quill'
import { getFontSizeList } from "../../helper";
import FontSlide from "./FontSlide";
import ColorPicker from "../../ColorPicker/ColorPicker";
import Dropdown from "../../Inputs/Dropdown";
import ColorBlock from "../../Inputs/ColorBlock";
const Size = Quill.import('attributors/style/size');
const Font = Quill.import("formats/font");
const whiteListedSizes = getFontSizeList()
Size.whitelist = whiteListedSizes
Quill.register(Size, true);
const familyStyles = [
  "arial",
  "comic-sans",
  "courier-new",
  "georgia",
  "helvetica",
  "lucida"
]
Font.whitelist = familyStyles
Quill.register(Font, true)


@inject('workAreaStore', 'sidebarStore') @observer
class TextStyleSlide extends React.Component {

  constructor(props){
    super(props)
    this.state = {
      scrollPos: 0,
      opacity: 1,
      fontSearch: '',
      familyFilterOpen: false,
      fontFamilies: [
        {
          selected: true,
          title: 'all',
          value: 'all'
        },
        {
          selected: false,
          title: 'display',
          value: 'display'
        },
        {
          selected: false,
          title: 'serif',
          value: 'serif'
        },
        {
          selected: false,
          title: 'sans-serif',
          value: 'sans-serif'
        },
        {
          selected: false,
          title: 'handwriting',
          value: 'handwriting'
        },
        {
          selected: false,
          title: 'monospace',
          value: 'monospace'
        }
      ],
      textColor: '',
      shadowColor: '',
      shadowColorOpen: false,
      shadowValue: null
    }
    this._searchDebounce = null
  }

  closeSlide(){
    const { sidebarStore, workAreaStore } = this.props
    this.props.workAreaStore.setFontFamily('')
    if(workAreaStore.fontSelect){
      workAreaStore.toggleFontSelect(false)
      return
    }
    sidebarStore.setTextStyleSlide(false)
    sidebarStore.closeSidebarSlide()
    workAreaStore.setHidden(false)
    workAreaStore.unsetAllEditingText()
  }

  toggleFamilyDropdown(){
    this.setState({
      familyFilterOpen: !this.state.familyFilterOpen
    })
  }

  componentDidMount(){
    const layer = this.props.workAreaStore.getSelectedLayer()
    if(this.props.workAreaStore.fontFamily){
      const filter = this.props.workAreaStore.fontFamily
      const copy = [...this.state.fontFamilies]
      copy.forEach(el => {
        if(el.value === filter && !el.selected){
          el.selected = true
        }else{
          el.selected = false
        }
        if(!filter && el.value === 'all'){
          el.selected = true
        }
      })
      this.setState({
        fontFamilies: copy
      })
    }
    if(layer && layer.textShadow){
      this.setState({
        shadowColor: layer.textShadow.color
      })
    }
    if(this.state.fontSearch.length || (this.props.workAreaStore.fontKeyword && this.props.workAreaStore.fontKeyword.length)){
      this.props.workAreaStore.getFonts('', true)
    }
    this.setState({
      textColor: this.props.workAreaStore.lastTextColor ? this.props.workAreaStore.lastTextColor : 'FFFFFF',
      fontSearch: ''
    })
  }

  setTargetVal(e, value, selector){
    const cl = document.querySelector(selector)
    cl.setAttribute('value', String(value))
    e.target.setAttribute('value', String(value))
    e.target.value = String(value)
  }

  handleShadowSliderChange(e, xAxis = false, yAxis = false){   
    const layer = this.props.workAreaStore.getSelectedLayer()
    if(!layer){
      return
    }
    const idHash = btoa(layer.id)
    let selector = `#text-toolbar-${idHash}`
    const isForm = e.target && e.target.className && e.target.className === 'form-control'
    let add = ''
    if(isForm){
      add += 'Input'
    }
    const base = `.text-toolbar-${idHash}`
    let baseVal = Math.floor(e.target.value)
    const valStr = String(e.target.value).split('')
    if(valStr.length >= 2 && valStr[0] === '0' || (valStr[0] === '-' && valStr[1] === '0')){
      let sliceIdx = 0
      if(valStr[0] === '-'){
        sliceIdx = 1
      }
      valStr.splice(sliceIdx, 1)
      baseVal = Number(valStr.join(''))
    }
    const val = Number(baseVal)
    if(isForm){
      this.setTargetVal(e, String(baseVal), `${base} .text-shadow-${xAxis ? 'x' : 'y'} .prop-control.form-control`)
    }
    if(xAxis){
      if(layer.textShadow.x < val){
        selector += ` .ql-increaseShadowX` + add
      }else{
        selector += ` .ql-decreaseShadowX` + add
      }
    }
    if(yAxis){
      if(layer.textShadow.y < val){
        selector += ` .ql-increaseShadowY` + add
      }else{
        selector += ` .ql-decreaseShadowY` + add
      }
    }
    const btn = document.querySelector(selector)
    btn.click()
    if(isForm){
      e.target.focus()
    }
  }

  toggleTextShadow(e){
    const layer = this.props.workAreaStore.getSelectedLayer()
    if(!layer){
      return
    }
    const idHash = btoa(layer.id)
    let selector = `#text-toolbar-${idHash} .ql-toggleShadow`
    const btn = document.querySelector(selector)
    if(btn){
      btn.click()
    }
  }

  handleSliderChange(e, spacing=false, lineheight = false, fontSize = false){
    const layer = this.props.workAreaStore.getSelectedLayer()
    if(!layer){
      return
    }
    const idHash = btoa(layer.id)
    let selector = `#text-toolbar-${idHash}`
    const isForm = e.target && e.target.className && e.target.className === 'form-control'
    let add = ''
    if(isForm){
      add += 'Input'
    }
    let baseVal = Math.floor(e.target.value)
    const valStr = String(e.target.value).split('')
    if(valStr.length >= 2 && valStr[0] === '0' || (valStr[0] === '-' && valStr[1] === '0')){
      let sliceIdx = 0
      if(valStr[0] === '-'){
        sliceIdx = 1
      }
      valStr.splice(sliceIdx, 1)
      baseVal = Number(valStr.join(''))
    }
    const base = `.text-toolbar-${idHash}`
    if(spacing){
      const val = Number(baseVal) / 1000
      if(isForm){
        this.setTargetVal(e, String(baseVal), `${base} .text-spacing-slider`)
      }
      if(layer.spacing < val){
        selector += ' .ql-increaseSpacing' + add
        const increaseBtn = document.querySelector(selector)
        increaseBtn.click()
      }else{
        selector += ' .ql-decreaseSpacing' + add
        const decreaseBtn = document.querySelector(selector)
        decreaseBtn.click()
      }
    }else if(fontSize){
      const val = (Number(baseVal)).toFixed(0)
      if(isForm){
        this.setTargetVal(e, String(Number(baseVal.toFixed(0))), `${base} .font-size-slider`)
      }
      if(layer.lineHeight < val){
        selector += ' .ql-increaseFontSize' + add
        const increaseBtn = document.querySelector(selector)
        increaseBtn.click()
      }else{
        selector += ' .ql-decreaseFontSize' + add
        const decreaseBtn = document.querySelector(selector)
        decreaseBtn.click()
      }
      if(isForm){
        e.target.focus()
      }
      return
    }else if (lineheight) {
      const val = Number((Number(baseVal) / 1000).toFixed(2))
      if(isForm){
        this.setTargetVal(e, String(Number(baseVal.toFixed(0))), `${base} .text-lineheight-slider`)
      }
      if(layer.lineHeight < val){
        selector += ' .ql-increaseLineheight' + add
        const increaseBtn = document.querySelector(selector)
        increaseBtn.click()
      }else{
        selector += ' .ql-decreaseLineheight' + add
        const decreaseBtn = document.querySelector(selector)
        decreaseBtn.click()
      }
      if(isForm){
        e.target.focus()
      }
      return
    }else{
      const val = Number(baseVal) / 100
      if(isForm){
        this.setTargetVal(e, String(baseVal), `${base} .text-opacity-slider`)
      }
      if(layer.opacity < val){
        selector += ' .ql-increaseOpacity' + add
        const btn = document.querySelector(selector)
        btn.click()
      }else{
        selector += ' .ql-decreaseOpacity' + add
        const btn = document.querySelector(selector)
        btn.click()
      }
    }
    if(isForm){
      e.target.focus()
    }
  }

  resetSlider(handler, inputClass, spacing, lineheight){
    const el = document.querySelector(`.slider.${inputClass}`)
    if(!el){
      return
    }
    const e = {
      target: {
        value: 0
      }
    }
    if(spacing){
      el.value = 0
      handler(e, true)
    }
    if(lineheight){
      el.value = 140
      e.target.value = 140
      handler(e, false, true)
    }
    if(!lineheight && !spacing){
      el.value = 100
      e.target.value = 100
      handler(e)
    }
  }

  getSliderRow(min, max, changeHandler, title, className, inputClass, propValue, spacing = false, lineheight = false){
    if(isNaN(propValue)){
      return <div />
    }
    return (
        <div className={'row no-gutters mt-3 ' + className}>
        <div className='col-4'>
          <span>{title}</span>
        </div>
        <div className="col-6">
          <input 
            onDoubleClick={() => this.resetSlider(changeHandler, inputClass, spacing, lineheight)}
            className={"slider " + inputClass}
            type='range'
            min={min} 
            max={max}
            onChange={changeHandler}
            style={{
              backgroundSize: (propValue - min) * 100 / (max - min) + '% 100%'
            }}
            value={propValue}
          />
        </div>
        <div className='col-2'>
          <div 
            className='prop-display prop-control form-control'
            style={{width: '100%'}}
          >
            <input
              type='number'
              min={min}
              max={max}
              step={1}
              className='form-control'
              onChange={changeHandler}
              value={propValue}
            />
          </div>
        </div>
      </div>
    )
  }

  resetShadowSlider(handler, inputClass, yAxis = false){
    const el = document.querySelector(`.slider.${inputClass}`)
    if(!el){
      return
    }
    const e = {
      target: {
        value: 0
      }
    }
    el.value = 0
    handler(e, !yAxis, yAxis)
  }

  getShadowRow(min, max, changeHandler, title, className, inputClass, propValue, yAxis = false){
    if(isNaN(propValue)){
      return <div />
    }
    return (
      <div className={'row no-gutters mt-3 ' + className}>
        <div className='col-4'>
          <span>{title}</span>
        </div>
        <div className="col-6">
          <input 
            //onDoubleClick={() => this.resetSlider(changeHandler, inputClass, spacing, lineheight)}
            className={"slider " + inputClass}
            type='range'
            min={min} 
            max={max}
            onChange={changeHandler}
            onDoubleClick={() => this.resetShadowSlider(changeHandler, inputClass, yAxis)}
            style={{
              backgroundSize: (propValue - min) * 100 / (max - min) + '% 100%'
            }}
            value={propValue}
          />
        </div>
        <div className='col-2'>
          <div 
            className='prop-display prop-control form-control'
            style={{width: '100%'}}
          >
            <input
              type='number'
              min={min}
              max={max}
              step={1}
              className='form-control'
              onChange={changeHandler}
              value={propValue}
            />
          </div>
        </div>
      </div>
    )
  }

  toggleShadowInput(){
    this.setState({
      shadowColorOpen: !this.state.shadowColorOpen
    })
  }

  getShadowColorInput(changeHandler, title, className, propValue){
    return (
      <div className={'row no-gutters mt-3 ' + className}>
        <div className='col-6'>
          <span>{title}</span>
        </div>
        <div className='col-2 offset-4 shadow-color'>
          <div className="shadow-color__preview" onClick={this.toggleShadowInput.bind(this)} style={{ background: propValue }} />
          {
            this.state.shadowColorOpen ? (
              <HexColorPicker
                color={propValue}
                className='shadow-color-picker'
                onChange={color => changeHandler(color)}
              />
            )
            :
            undefined
          }
        </div>
      </div>
    )
  }

  handleShadowColorChange(color){
    const idHash = 'text-toolbar-' + btoa(this.props.id)
    const btn = document.querySelector(`#${idHash} .ql-changeShadowColor`)
    this.setState({ shadowColor: color })
    if(btn){
      btn.click()
    }
  }

  getFontRow(selectedFont){
    return (
      <div className='row'>
        <div className='col-12 mb-3' onClick={e => this.handleFontSelectClick(e)}>
          <div className='form-control text-font-select' style={{width: '100%'}}>
            <CaretDown />
            <div className='option'>{selectedFont || 'Arial'}</div>
          </div>
        </div>
      </div>
    )
  }

  handleFontSelectClick(e){
    e.preventDefault()
    e.target.blur()
    window.focus()
    const { workAreaStore } = this.props
    workAreaStore.toggleFontSelect(!workAreaStore.fontSelect)
    if(this.props.workAreaStore.loadedFonts.length === 0 && !this.props.workAreaStore.fontsLoading){
      this.fetchFonts()
    }
  }

  async fetchFonts(){
    const { workAreaStore } = this.props
    await workAreaStore.getFonts(this.state.fontSearch)
  }
  
  async handleFontScroll(e){
    const { workAreaStore, sidebarStore: { textStyleOpen } } = this.props
    if(this.state.fontSearch.length > 0){
      return
    }
    if(workAreaStore.fontSelect && textStyleOpen){
      const { target } = e
      const { scrollHeight, scrollTop } = target
      const windowHeight = window.innerHeight
      const scrollPos = Math.floor(scrollTop + windowHeight)
      if(scrollPos >= scrollHeight - 60 && !this.props.workAreaStore.fontsLoading){
        await this.props.workAreaStore.getFonts(this.state.fontSearch)
      }
    }
  }

  handleColorChange(color){
    const root = document.querySelector('#root')
    if(root && root.scrollTop > 0){
      root.scrollTo(0, 0)
    }
    this.setState({
      textColor: color
    })
    const idHash = 'text-toolbar-' + btoa(this.props.id)
    const optsSelect = `#${idHash} select.ql-colorChange`
    const parent = document.querySelector(optsSelect)
    const selector = optsSelect + ` option[value="${color}"]`
    const existingColor = document.querySelector(selector)
    parent.childNodes.forEach(node => {
      if(node.hasAttribute('selected')){
        node.removeAttribute('selected')
      }
    })
    if(existingColor){
      existingColor.setAttribute('selected', 'selected')
      parent.value = existingColor.value
    }else{
      const el = document.createElement('option')
      el.value = color
      el.setAttribute('selected', 'selected')
      parent.appendChild(el)
      parent.value = color
    }
    parent.dispatchEvent(new Event('change'))
  }

  handleColorInputChange = color => {
    if(color.length >= 7){
      this.setState({
        textColor: color
      })
      this.handleColorChange(color)
    }
  }

  togglePicker(){
    this.props.sidebarStore.setTextColorPicker(!this.props.sidebarStore.showTextPicker)
  }

  removeZeroPixelOption(){
    const fontSizePicker = document.querySelector(`#text-toolbar-${btoa(this.props.id)} .font-size-col .ql-picker [data-value="0px"]`)
    if(fontSizePicker){
      fontSizePicker.remove()
    }
  }

  handleSlideClick(e){
    const className = e.target.className
    const isColorful = typeof(className) === 'string' && (className.includes('react-colorful') || className.includes('color-btn') || className.includes('ql-changeShadowColor') || className.includes('shadow-color'))
    if(isColorful){
      return
    }
    if(!isColorful && this.props.sidebarStore.showTextPicker){
      this.props.sidebarStore.setTextColorPicker(false)
    }
    if(!isColorful){
      this.setState({
        shadowColorOpen: false
      })
    }
  }

  checkIfElement(){
    const { workAreaStore, sidebarStore } = this.props
    const layer = workAreaStore.getSelectedLayer()
    if(layer && (layer.type === 'element' || layer.type === 'svg' || layer.type === 'svgGroup') && sidebarStore.open){
      sidebarStore.closeSidebarSlide()
      sidebarStore.changeStatus('color-picker')
    }
  }

  componentDidUpdate(prevProps){
    //this.checkIfElement()
    if(
      this.props.textId === this.props.workAreaStore.editingTextId && 
      this.props.workAreaStore.lastTextColor && 
      prevProps.lastColor !== this.props.workAreaStore.lastTextColor &&
      this.props.activeItem && 
      this.props.activeItem.id === 'custom-text-style'
    ){
      this.setState({
        textColor: this.props.workAreaStore.lastTextColor
      })
    }
  }

  handleSearchChange(e){
    const { name, value } = e.target
    this.setState({
      [name]: value
    })
    if(value === ''){
      this.props.workAreaStore.getFonts(value, true)
      return
    }
    if(value !== '' && value.length < 3){
      return
    }
    clearTimeout(this._searchDebounce)
    this._searchDebounce = setTimeout(async () => {
      this.props.workAreaStore.getFonts(value)
    }, 500)
  }

  async handleFamilySelect(selectedVal){
    const copy = [...this.state.fontFamilies]
    copy.forEach(el => {
      el.selected = false
    })
    const idx = copy.findIndex(({ value }) => value === selectedVal)
    copy[idx].selected = true
    const current = this.state.fontFamilies.find(({ selected }) => selected)
    if(copy[idx].selected.value !== current.value){
      if(selectedVal === 'all'){
        this.props.workAreaStore.setFontFamily('')
      }else{
        this.props.workAreaStore.setFontFamily(selectedVal)
      }
      this.toggleFamilyDropdown()
      await this.props.workAreaStore.getFonts(this.state.fontSearch, true)
    }else{
      return
    }
  }

  selectColorFromBlock(color){
    this.handleColorChange(color)
  }

  render(){
      const { 
        workAreaStore,
        sidebarStore: { textStyleOpen, showTextPicker: showPicker },
        id
      } = this.props
      const layer = workAreaStore.getSelectedLayer()
      const displayGeneral = textStyleOpen && layer && layer.selected && layer.id === workAreaStore.editingTextId && id === workAreaStore.editingTextId
      const textDisplay = { 
        display: (displayGeneral && !workAreaStore.fontSelect) ? 'block' : 'none'
      }
      const fontDisplay = {
        display: (displayGeneral && workAreaStore.fontSelect) ? 'block' : 'none'
      }
      const idHash = btoa(id)
      const toolbarId = `text-toolbar-${idHash}`
      const opc = layer ? layer.opacity*100 : 0
      const spacing = layer ? layer.spacing : 0
      const lineHeight = layer ? layer.lineHeight * 100 : 0
      const shadowX = layer && layer.textShadow && layer.textShadow.x ? layer.textShadow.x : 0
      const shadowY = layer && layer.textShadow && layer.textShadow.y ? layer.textShadow.y : 0
      const fontSize = layer && layer.size ? layer.size : 0
      const showShadow = layer && layer.textShadow && layer.textShadow.display
      return (
        <div 
          className={"sidebar-slide text-style-slide " + toolbarId}
          onScroll={e => this.handleFontScroll(e)}
          style={{ display: displayGeneral ? 'block' : 'none'}}
          onClick={e => this.handleSlideClick(e)}
        >
          <div className="slide-menu font-slide-menu">
            <h5 style={{fontSize: '16px'}}>Text styling</h5>
            <div className="slide-menu__close">
              <span onClick={() => this.closeSlide()} className='slide-menu__close__icon'>
                <CloseIcon />
              </span>
            </div>
          </div>
          <div 
            className='slide-wrapper' style={fontDisplay}
          >
            <div 
              className='row no-gutters text-style-slide__font-tools'
            >
              <div className='row no-gutters text-style-slide__font-tools__filters'>
                <div className='col-12'>
                  <input 
                    className='form-control font-search'
                    name='fontSearch'
                    value={this.state.fontSearch}
                    onChange={e => this.handleSearchChange(e)}
                    placeholder='Search for a font'
                  />
                  <Dropdown
                    options={this.state.fontFamilies}
                    customStyle={{
                      width: '200px',
                      zIndex: 100
                    }}
                    caret={true}
                    className={'font-family-dropdown'}
                    isOpen={this.state.familyFilterOpen}
                    onClick={this.handleFamilySelect.bind(this)}
                    toggle={this.toggleFamilyDropdown.bind(this)}
                  />
                </div>
              </div>
              <FontSlide fontSearch={this.state.fontSearch} />
            </div>
          </div>
          <div className="slide-wrapper" style={textDisplay}>
          <div className="row no-gutters text-style-slide__tools">
              <div className='col-12'>
                {this.getFontRow(
                  layer && layer.type === 'text' ? layer.font.value : 'Arial', (e) => this.handleFontSelectClick(e)
                )}
              </div>
              <div className='col-12'>
                <div className="text-style-slide row no-gutters" id={toolbarId}>
                  <div className="col-8 align-center">
                    <div className="row">
                      <div className="col-12">
                        <button className='ql-align' value="" />
                        <button className='ql-align' value="center" />
                        <button className='ql-align' value="right" />
                        <button className='ql-align' value="justify" />
                      </div>
                      <div className="col-12">
                        <button className="ql-bold" />
                        <button className="ql-italic" />
                        <button className="ql-underline" />
                        <select className="ql-colorChange" style={{display: 'none'}} />
                      </div>
                    </div>
                  </div>
                  <div className='col-4 font-size-col'>
                    <select 
                      className="ql-size"
                    >
                        {
                          whiteListedSizes.map((size, idx) => {
                            return (
                                <option 
                                key={idx} 
                                value={size}
                              >{size}</option>
                            )
                        })
                      }
                    </select>
                  </div>
                  <button className="ql-increaseShadowX" style={{display: 'none'}} />
                  <button className="ql-decreaseShadowX" style={{display: 'none'}} />
                  <button className="ql-increaseShadowY" style={{display: 'none'}} />
                  <button className="ql-decreaseShadowY" style={{display: 'none'}} />


                  <button className="ql-increaseFontSize" style={{display: 'none'}} />
                  <button className="ql-decreaseFontSize" style={{display: 'none'}} />
                  <button className="ql-increaseFontSizeInput" style={{display: 'none'}} />
                  <button className="ql-decreaseFontSizeInput" style={{display: 'none'}} />

                  <button className="ql-increaseShadowXInput" style={{display: 'none'}} />
                  <button className="ql-decreaseShadowXInput" style={{display: 'none'}} />
                  <button className="ql-increaseShadowYInput" style={{display: 'none'}} />
                  <button className="ql-decreaseShadowYInput" style={{display: 'none'}} />

                  <button className="ql-toggleShadow" style={{display: 'none'}} />

                  <button className="ql-increaseLineheightInput" style={{display: 'none'}} />
                  <button className="ql-decreaseLineheightInput" style={{display: 'none'}} />
                  <button className="ql-increaseLineheight" style={{display: 'none'}} />
                  <button className="ql-decreaseLineheight" style={{display: 'none'}} />
                  <button className="ql-changeShadowColor" style={{display: 'none'}} />

                  <button className="ql-increaseSpacingInput" style={{display: 'none'}} />
                  <button className="ql-decreaseSpacingInput" style={{display: 'none'}} />
                  <button className="ql-increaseSpacing" style={{display: 'none'}} />
                  <button className="ql-decreaseSpacing" style={{display: 'none'}} />
                  <button className="ql-increaseOpacity" style={{display: 'none'}} />
                  <button className="ql-decreaseOpacity" style={{display: 'none'}} />
                  <button className="ql-increaseOpacityInput" style={{display: 'none'}} />
                  <button className="ql-decreaseOpacityInput" style={{display: 'none'}} />
                  <button className='ql-changeFont' style={{display: 'none'}} />
                </div>
              </div>
              <div className='col-12 mt-1'>
                <div className='shadow-controls'>
                  <label>Text Shadow</label>
                  <input 
                    type='checkbox'
                    className='form-control cursor-pointer shadow-toggle'
                    onChange={(e) => this.toggleTextShadow(e)}
                    checked={showShadow}
                  />
                </div>
                <div className='fade' style={{ display: showShadow ? 'initial' : 'none', opacity: showShadow ? 1 : 0 }}>
                  {this.getShadowColorInput(this.handleShadowColorChange.bind(this), 'Shadow color', 'text-shadow-color', this.state.shadowColor)}
                  {this.getShadowRow(-25, 25, e => this.handleShadowSliderChange(e, true), 'Shadow X', 'text-shadow-x', 'text-shadow-x-slider', shadowX, false)}
                  {this.getShadowRow(-25, 25, e => this.handleShadowSliderChange(e, false, true), 'Shadow Y', 'text-shadow-y', 'text-shadow-y-slider', shadowY, true)}
                  <div className='shadow-border' />
                </div>
                {this.getSliderRow(
                  1, 1000, e => this.handleSliderChange(e, false, false, true), 'Font size', `font-size-row`, 'font-size-slider', Number(fontSize.toFixed(0)), false, true
                )}
                {this.getSliderRow(
                  1, 1000, e => this.handleSliderChange(e, false, true), 'Line height', `lineheight-row${showShadow ? ' visible-shadow' : ''}`, 'text-lineheight-slider', Number(lineHeight.toFixed(0)), false, true
                )}
                {this.getSliderRow(
                  -1000, 1000, e => this.handleSliderChange(e, true), 'Spacing', 'spacing-row', 'text-spacing-slider', spacing, true
                )}
                {this.getSliderRow(
                  -1, 100, e => this.handleSliderChange(e), 'Opacity', 'opacity-row', 'text-opacity-slider', opc
                )}
              </div>
              <div className='col-12 text-style-slide__subtitle-wrapper'>
                  <span className='text-style-slide__subtitle'>
                    Text color
                  </span>
              </div>
              <div className='col-12 palette-col' style={{ padding: '0px' }}>
                {
                  workAreaStore.activeBrand ?
                  (
                    workAreaStore.activeBrand.palettes.map((list, idx) => {
                      const colorlist = list.colors.map(color => {
                        return {
                          selected: false,
                          color
                        }
                      })
                      return (
                        <div key={idx} className='palette-col__project-palette'>
                          {
                            <ColorBlock
                              titleStyle={{
                                paddingLeft: '0px'
                              }}
                              title={list.name}
                              colors={colorlist}
                              objName={idx}
                              onClick={this.selectColorFromBlock.bind(this)}
                            />
                          }
                        </div>
                      )
                    })
                  )
                  :
                  undefined
                }
              </div>
              <div className='col-12 color-col'>
                <div className='row'>
                  <HexColorPicker
                    color={this.state.textColor}
                    className='text-color-picker'
                    onChange={(color) => this.handleColorChange(color)}
                  />
                  <HexColorInput
                    alpha
                    color={this.state.textColor}
                    className='form-control text-color-input'
                    onChange={color => this.handleColorInputChange(color)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )
  }

}

/*

    <div className='col-3 mb-3 no-gutters'>
      <div className='color-btn custom' onClick={() => this.togglePicker()} />
    </div>
}else{
*/


export default TextStyleSlide